/**
 * @title grocery-delivery-checker.js: Sub-module
 * @description 
 * This JS file binds the apply  button 
 * and  functionalities to 
 * respective event listeners
 *  
 */ 
define([], function() {
	 var CanadaGroceryDeliveryChecker = {
			 init : function() {
				 if (window.location.href.indexOf("CanadaGroceryDeliveryRedirect") > -1 && wcs.storeId==="10302") {
					 CanadaGroceryDeliveryChecker.initialize(); 
				 }
			 },  
		        /**
		         * The method initializes the binding for different 
		         * JSP elements and is the starting point for most of 
		         * the actions.
		         */
	        initialize : function(){
	        	let zipCode = $.cookie('invCheckPostalCode');
				if (zipCode !== null) {
					let zipCodeDisplay = zipCode.replace(/[^a-zA-Z 0-9]+/g, ' ');
					
					//handles case of zipcode looking like: M1R+0E9
					zipCode = zipCode.replace(/[^a-zA-Z 0-9]+/g, '');
					//handles case of zipcode looking like: M1R 0E9
					zipCode = zipCode.replace(/\s/g, '');
					$('.user-entered-zip').text(zipCodeDisplay);
					
					if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
						let updateZipCodeStateCookies = function(data, textstatus, XMLHttpRequest) {
				    					
							let locationData = COSTCO.Header.extractLocationData(data);
							let invalidZip = locationData.InvalidZip;
					    	let province = locationData.Province;
							let country = locationData.Country;
							
				  	  		if(!invalidZip) {
				  	  			COSTCO.Header.setDeliveryCookies(zipCode, province, country);
				  	  			
					  	  		let stateCode = $.cookie('invCheckStateCode'); 
						    	if (typeof(stateCode) !== 'undefined' && stateCode != null  && stateCode.length > 2) {
						    		stateCode = stateCode.substring(2);
					        	}
								CanadaGroceryDeliveryChecker.checkTwoDayEligible(stateCode, zipCode);
				  	  		}
						};
						if ($('#isGeocodeService').val() != "true") {
							COSTCO.util.callBing(zipCode, updateZipCodeStateCookies, updateZipCodeStateCookies);
				    	} else {
				    		COSTCO.util.callGeocodeAPI(zipCode, updateZipCodeStateCookies, updateZipCodeStateCookies);
				    	}
					} else {
				    	let stateCode = $.cookie('invCheckStateCode'); 
				    	if (typeof(stateCode) !== 'undefined' && stateCode != null  && stateCode.length > 2) {
				    		stateCode = stateCode.substring(2);
			        	}
						CanadaGroceryDeliveryChecker.checkTwoDayEligible(stateCode, zipCode);
					}
				} 
				$(window).on('load', function() {
					COSTCO.util.click_popover('#two-day-postal-code-changer', '#ca-grocery-delivery-postal-code-popover');
					COSTCO.util.click_popover('#same-day-postal-code-changer', '#ca-grocery-delivery-postal-code-popover');
				});
				
			},
	        /**
	         * Calls AjaxDeliveryWarehouseLocatorCmd to validate and save Aeroplan Account Number
	         * @param
	         * @return void
	         */
	        checkTwoDayEligible: function(stateCode, zipCode, groceryDeliveryCategory) {  
				//let stateCode = "AB";
				
				// test no two day delivery
	        	//let zipCode = "Y0B1M0";
	        	
	        	// test two day delivery
	        	// let zipCode = "M1R0E9";
	        	
		        COSTCO.util.ajax({
			          type: 'GET',
			          url: 'AjaxDeliveryWarehouseLocatorCmd?stateCode=' +stateCode +"&zipCode="+zipCode+"&storeId="+wcs.storeId,
			          done: function(data) {
			        	  let responseJson=JSON.parse(data);
			        	  var status= responseJson.omsResponse;
			        	  if (status === true) {
			        		if (responseJson.SameDay === true) {
			        			$('#same-day-delivery-row-success').removeClass('hidden');
				        		$('#same-day-delivery-row-failure').addClass('hidden');
				        		COSTCO.util.announceSRMessage(messages.SAMEDAY_AVAILABLE);
			        		} else {
			        			$('#same-day-delivery-row-success').addClass('hidden');
				        		$('#same-day-delivery-row-failure').removeClass('hidden');
				        		COSTCO.util.announceSRMessage(messages.SAMEDAY_NOT_AVAILABLE);
			        		}
			        		if (responseJson.Regional === true) {
			        			$('#two-day-delivery-row-success').removeClass('hidden');
				        		$('#two-day-delivery-row-failure').addClass('hidden');
				        		if(groceryDeliveryCategory == 'two-day-postal-code-changer') {
				        			COSTCO.util.announceSRMessage(messages.GROCERY_AVAILABLE);	
				        		}
				        	} else {
			        			$('#two-day-delivery-row-success').addClass('hidden');
			        			$('#two-day-delivery-row-failure').removeClass('hidden');
			        			if(groceryDeliveryCategory == 'two-day-postal-code-changer') {
				        			COSTCO.util.announceSRMessage(messages.GROCERY_NOT_AVAILABLE);	
				        		}
				        	}
			        	  }
			          },
			          timeout: wcs.ajaxTimeout,
			          fail: function(x, t, m) {
			            if (t === 'timeout') {
			              console.error('Error AJAX timeout.');
			            } else {
			              console.error('Unexpected AJAX error.');
			            }
			          }
			        }); 
			},
	        useZipcodeSubmitPopover: function(element) {
	        	let userEnteredZip = $('#postal-code-input-grocery').val().toUpperCase();
	        	let userEnteredZipSubmit = userEnteredZip.replace(/ /g, '');
	        	userEnteredZip = userEnteredZip.replace(/ /g, ' ');
	        	let groceryDeliveryCategory = $('input[name="category-grocery-delivery"]').val();
	        	
	        	if (userEnteredZip.length === 0) {
	        		let errorContainer = $(element).find('div.error');
					if(errorContainer) {
						errorContainer.empty();
					}
					
	        		if(errorContainer) {
	  	  				errorContainer.append(messages.ERR_GROCERY_INVALID_ZIP);
	  	  			}
	  	  			let inputContainer = $(element).find('.form-control');
	  	  			if(inputContainer){
	  	  				inputContainer.attr('aria-invalid','true');
	  	  				inputContainer.addClass("error");
	  	  			}
	        	} else {
	        		$('.user-entered-zip').text(" " + userEnteredZip + " ");
	        		let userSavedProvince = $.cookie('invCheckStateCode');
		        	if (!userSavedProvince) {
		        		userSavedProvince = $.cookie('C_LOC');
		        		
		        	}
		        	if (userSavedProvince.length > 2) {
		        		userSavedProvince = userSavedProvince.substring(2);
		        	}
		        	CanadaGroceryDeliveryChecker.checkTwoDayEligible(userSavedProvince, userEnteredZipSubmit, groceryDeliveryCategory);
	        	}
	        	
	        }   
	 }
	 if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	 
	 

		if (typeof window.COSTCO.Global == 'undefined') {
			document.addEventListener("CostcoGlobalLoaded", CanadaGroceryDeliveryChecker.init, false);
		}
		else {
			CanadaGroceryDeliveryChecker.init();
		}

		window.COSTCO.CanadaGroceryDeliveryChecker = CanadaGroceryDeliveryChecker;
		return CanadaGroceryDeliveryChecker;
});


// WEBPACK FOOTER //
// ./js/global/grocery-delivery-checker.js